import React from 'react';
import Download856Modal from '../../../Widgets/Download856Modal/Download856Modal';
import DownloadUniformFile from '../../../Widgets/DownloadUniformFile/DownloadUniformFile';

const DownloadModals = ({
    show856Modal, setShow856Modal,
    showUniformFileModal, setShowUniformFileModal,
    client, token
}) => (
    <>
        <Download856Modal
            open={show856Modal}
            onClose={() => setShow856Modal(false)}
            client={client}
            token={token}
        />
        <DownloadUniformFile
            open={showUniformFileModal}
            onClose={() => setShowUniformFileModal(false)}
            client={client}
            token={token}
        />
    </>
);

export default DownloadModals;
